<div class="contents-area" (dragstart)="onDragstartBody($event)">
  <div class="block-column">
    <div class="column-list">

          <label class="list-input-title">対象</label>
          <div class="list-input-content">
            <app-radio-label id="rdb_PlanCategory" #rdb_PlanCategory [subid]="'rdb_PlanCategory'"
              [(ngModel)]="this.kymw5300Model.stockLimitFlg" [name]="'stockLimitFlg'" [label]="'商品企画マスタ'" [value]="'0'"
              autoFocus="true" (change)="eventchkPlanCategoy_CLICKHandler()" [forcedEnabledMode]="'none'">
            </app-radio-label>
            <app-radio-label id="rdb_StockCategory" #rdb_StockCategory [subid]="'rdb_StockCategory'"
              [(ngModel)]="this.kymw5300Model.stockLimitFlg" [name]="'stockLimitFlg'" [label]="'在庫限定'" [value]="'1'"
              (change)="eventchkStockCategory_CLICKHandler()" [forcedEnabledMode]="'none'">
            </app-radio-label>
          </div>
      <label class="list-input-title">受注コード</label>
      <div class="list-input-content">
        <app-order-code-text-input id="txti_OrderCode" #txti_OrderCode [subid]="'txti_OrderCode'"
          [(ngModel)]="this.kymw5300Model.orderCode" [required]="true" [catalogIDField]="lbl_CatalogId"
          [autofocus]="true" (ngModelChange)="eventOrderCode_CHANGEHandler()" [forcedEnabledMode]="'none'"
          [tabindex]="0">
        </app-order-code-text-input>
      </div>

      <label class="list-input-title">配達企画回（翌週）</label>
        <div class="list-input-content">
          <input type="text" class="deliv-catalog" id="lbl_CatalogId" #lbl_CatalogId readonly>
        </div>
    </div>
  </div>

  <div class="block-row">
    <div>
      <h1>カテゴリ一覧</h1>
      <div class="element-column">
        <div class="block-row">
          <button class="btn-secondary" id="btn_Display" #btn_Display (click)="eventDisplay_CLICKHandler()"
            forcedEnabledMode="none" [tabindex]="0">表示</button>
        </div>

        <div class="element-row">
          <div class="element-column">
            <wj-tree-view [style.width.px]="800" [style.height.px]="642" class="card" id="tre_Category" #tre_Category
              [tabindex]="0" [itemsSource]="kymw5300Model.categoryInfoList" [displayMemberPath]="'CategoryName'"
              [childItemsPath]="'Category'" forcedEnabledMode="none" (itemClicked)="eventSelect_CLICKHandler(null)"
              (formatItem)="formatItem(tre_Category, $event)">
            </wj-tree-view>
            <div class="layout_balance">
              <button class="btn-tartiary warning" id="btn_Delete" #btn_Delete (click)="eventDelete_CLICKHandler()"
                forcedEnabledMode="" [tabindex]="0">削除</button>
              <div class="element-row">
                <button class="btn-secondary" id="btn_Makeroot" #btn_Makeroot (click)="eventMakeroot_CLICKHandler()"
                  forcedEnabledMode="" [tabindex]="0">新規ルートを作成</button>
                <button class="btn-secondary" id="btn_Addchild" #btn_Addchild (click)="eventAddchild_CLICKHandler()"
                  forcedEnabledMode="" [tabindex]="0">子を追加</button>
              </div>
            </div>
          </div>
          <div class="element-column">
            <button class="btn-secondary" id="btn_Upper" #btn_Upper (click)="eventUpper_CLICKHandler(null)"
              forcedEnabledMode="" [tabindex]="0">↑</button>
            <button class="btn-secondary" id="btn_Lower" #btn_Lower (click)="eventLower_CLICKHandler()"
              forcedEnabledMode="" [tabindex]="0">↓</button>
            <input type="text" id="txti_ToShowSeq" #txti_ToShowSeq [(ngModel)]="this.kymw5300Model.toShowSeq"
              plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3" forcedEnabledMode="" [tabindex]="0">
            <button class="btn-secondary" id="btn_Move" #btn_Move (click)="eventMove_CLICKHandler()"
              forcedEnabledMode="" [tabindex]="0">移動</button>
          </div>
        </div>
      </div>
    </div>

    <div>
      <h1>カテゴリ詳細</h1>
      <div class="column-list">
        <label class="list-input-title">カテゴリコード</label>
        <div class="list-input-content">
          <input type="text" style="width:7rem;" id="lbl_CategoryCode"
            value="{{ this.kymw5300Model.categoryCode }}" readonly>
        </div>

        <label class="list-input-title">カテゴリ名称</label>
        <div class="list-input-content">
          <app-not-null-text-input id="txti_CategoryName" #txti_CategoryName [subid]="'txti_CategoryName'"
            [useDisabledBgColor]="true" [(ngModel)]="this.kymw5300Model.categoryName" [restrict]="'[ -￮]'"
            [maxChars]="15" [fullOnly]="true" [displayCountField]="false" [forcedEnabledMode]="''" [tabindex]="0">
          </app-not-null-text-input>
        </div>

        <label class="list-input-title">親カテゴリ名称</label>
        <div class="list-input-content">
          <input type="text" id="lbl_CategoryParentName"
            value="{{ this.kymw5300Model.categoryParentName }}" readonly>
        </div>

        <label class="list-input-title">ボーダーライン表示</label>
        <div class="list-input-content">
          <app-code-combo-box id="cmb_BorderLineDiv" style="width:14rem;" #cmb_BorderLineDiv [subid]="'cmb_BorderLineDiv'"
            [(ngModel)]="this.kymw5300Model.borderLineDiv" [codeDiv]="'ctp091'" [forcedEnabledMode]="''" [tabindex]="0">
          </app-code-combo-box>
        </div>

        <label class="list-input-title">売場表示</label>
        <div class="list-input-content">
          <app-checkbox-label id="ckb_ShowDiv" #ckb_ShowDiv [subid]="'ckb_ShowDiv'"
            label="一時非表示にする" [(ngModel)]="this.kymw5300Model.showDiv" [forcedEnabledMode]="''" [tabindex]="0">
          </app-checkbox-label>
        </div>

        <label class="list-input-title">売場毎表示区分</label>
        <div class="list-input-content">
          <div class="element-column">
            <app-checkbox-label label="ブロードバンド" id="ckb_SellAreaDivB" #ckb_SellAreaDivB [subid]="'ckb_SellAreaDivB'"
              [(ngModel)]="this.kymw5300Model.sellAreaDivB" [forcedEnabledMode]="''" [tabindex]="0">
            </app-checkbox-label>
            <app-checkbox-label label="ナローバンド" id="ckb_SellAreaDivN" #ckb_SellAreaDivN [subid]="'ckb_SellAreaDivN'"
              [(ngModel)]="this.kymw5300Model.sellAreaDivN" [forcedEnabledMode]="''" [tabindex]="0">
            </app-checkbox-label>
            <app-checkbox-label label="携帯" id="ckb_SellAreaDivM" #ckb_SellAreaDivM [subid]="'ckb_SellAreaDivM'"
              [(ngModel)]="this.kymw5300Model.sellAreaDivM" [forcedEnabledMode]="''" [tabindex]="0">
            </app-checkbox-label>
            <app-checkbox-label label="WEBカタログ" id="ckb_SellAreaDivW" #ckb_SellAreaDivW [subid]="'ckb_SellAreaDivW'"
              [(ngModel)]="this.kymw5300Model.sellAreaDivW" [forcedEnabledMode]="''" [tabindex]="0">
            </app-checkbox-label>
            <app-checkbox-label label="スマートフォン" id="ckb_SellAreaDivS" #ckb_SellAreaDivS [subid]="'ckb_SellAreaDivS'"
              [(ngModel)]="this.kymw5300Model.sellAreaDivS" [forcedEnabledMode]="''" [tabindex]="0">
            </app-checkbox-label>
            <app-checkbox-label label="スポット" id="ckb_SellAreaDivSP" #ckb_SellAreaDivSP [subid]="'ckb_SellAreaDivSP'"
              [(ngModel)]="this.kymw5300Model.sellAreaDivSP" [forcedEnabledMode]="''" [tabindex]="0">
            </app-checkbox-label>
            <app-checkbox-label label="訴求カテゴリ" id="ckb_SellAreaDivEC" #ckb_SellAreaDivEC [subid]="'ckb_SellAreaDivEC'"
              [(ngModel)]="this.kymw5300Model.sellAreaDivEC" [forcedEnabledMode]="''" [tabindex]="0">
            </app-checkbox-label>
          </div>
        </div>

        <label class="list-input-title">カテゴリ区分</label>
        <div class="list-input-content" id="grp_CategoryDiv">
          <app-checkbox-label label="商品マスタ" id="ckb_CategoryDiv" #ckb_CategoryDiv [subid]="'ckb_CategoryDiv'"
          [(ngModel)]="this.kymw5300Model.categoryDiv" [forcedEnabledMode]="'none'" [tabindex]="0">
          </app-checkbox-label>
        </div>
      </div>
    </div>
  </div>
</div>

<footer class="footer-buttons">
  <button class="btn-tartiary warning" id="btn_Cancel" #btn_Cancel (click)="eventCancel_CLICKHandler(null)"
    forcedEnabledMode="" [tabindex]="0">追加取消</button>
  <button class="btn-primary" id="btn_Update" #btn_Update (click)="eventUpdate_CLICKHandler()" forcedEnabledMode=""
    [tabindex]="0" [disabled]="kymw5300Model.btn_Update">更新</button>
</footer>